import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/customer-signup',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::create
* @see app/Http/Controllers/CustomerSignupController.php:15
* @route '/customer-signup'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\CustomerSignupController::store
* @see app/Http/Controllers/CustomerSignupController.php:20
* @route '/customer-signup'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/customer-signup',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CustomerSignupController::store
* @see app/Http/Controllers/CustomerSignupController.php:20
* @route '/customer-signup'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\CustomerSignupController::store
* @see app/Http/Controllers/CustomerSignupController.php:20
* @route '/customer-signup'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::store
* @see app/Http/Controllers/CustomerSignupController.php:20
* @route '/customer-signup'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\CustomerSignupController::store
* @see app/Http/Controllers/CustomerSignupController.php:20
* @route '/customer-signup'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
export const success = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: success.url(options),
    method: 'get',
})

success.definition = {
    methods: ["get","head"],
    url: '/customer-signup/success',
} satisfies RouteDefinition<["get","head"]>

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
success.url = (options?: RouteQueryOptions) => {
    return success.definition.url + queryParams(options)
}

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
success.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: success.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
success.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: success.url(options),
    method: 'head',
})

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
const successForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: success.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
successForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: success.url(options),
    method: 'get',
})

/**
* @see [serialized-closure]:2
* @route '/customer-signup/success'
*/
successForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: success.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

success.form = successForm

const customerSignup = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    success: Object.assign(success, success),
}

export default customerSignup